import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

export const ProfileFlexRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
});

export const ProfileRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const ProfileContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),

  // Form-internal classes that the original `formStyle` and `screenContainerStyle`
  // overrode; we apply the same overrides via a parent selector rather than
  // passing class-name strings deep into <Form>. `formScrollContainer` is a
  // stable class string emitted by <Form>; the form's main container div is its
  // direct child.
  '& .formScrollContainer > div': {
    alignItems: 'flex-start !important',
    maxWidth: '1000px !important',
    overflow: 'visible !important',
  },
  '& .inputEach': {
    alignItems: 'flex-start',
  },
  '& .titleContainer': {
    marginBottom: 0,
  },
  '& .vendorsInnerContainer': {
    padding: 0,

    '& .vendorRealmContainer': {
      margin: 0,
    },
  },
}));

export const ProfileButtonContainer = styled('div')({
  maxWidth: 1000,
  margin: '0 auto 10px',
});

// Wrapper for the screen sections rendered inside <Form>; used as
// `screenContainer.component` so the Form delegates the wrapper element.
export const ProfileScreenContainer = styled('div', {
  shouldForwardProp: (p) => p !== 'isMobile',
})(({ theme, isMobile }) => ({
  width: '100%',
  ...(isMobile
    ? {
        maxWidth: 'none !important',
      }
    : {
        maxWidth: 400,
        padding: `0 ${theme.spacing(3)}`,
      }),
  '& .MuiInput-formControl.Mui-disabled, & .MuiInputLabel-formControl, & .Mui-disabled': {
    color: theme.palette.text.primary,
  },
  '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
    display: 'none',
  },
  '& .Mui-disabled.MuiInput-underline:before': {
    border: `none !important`,
  },
}));

// Paper wrapper for "access" panels (Company Access / Client Access).
export const ProfileAccessContainer = styled(Paper, {
  shouldForwardProp: (p) => p !== 'isMobile',
})(({ theme, isMobile }) => ({
  backgroundColor: theme.palette.background.paper,
  marginBottom: theme.spacing(2),
  padding: theme.spacing(2),
  width: '100%',
  ...(isMobile ? { maxWidth: 'none !important' } : { maxWidth: 400 }),
  '& .MuiFilledInput-root.Mui-disabled.MuiInputBase-formControl': {
    display: 'none',
  },
  '& .Mui-disabled.MuiInput-underline:before': {
    border: `none !important`,
  },
  '& .MuiInput-formControl.Mui-disabled, & .MuiInputLabel-formControl, & .MuiFormControlLabel-label.Mui-disabled': {
    color: theme.palette.text.primary,
  },
}));

export const ProfileChip = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.grey['100'],
  marginRight: 5,
}));

export const ProfileChipIcon = styled('span')(({ theme }) => ({
  color: theme.palette.success.main,
}));

export const ProfileDropZone = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.divider} !important`,
  borderRadius: `4px !important`,
  minHeight: 'auto !important',
  backgroundColor: 'transparent !important',
  '&:hover': {
    border: `1px solid ${theme.palette.text.primary} !important`,
  },
  '& p': {
    fontSize: '14px !important',
    textAlign: 'left !important',
    padding: `${theme.spacing(1)} ${theme.spacing(2)} !important`,
  },
  '& > div > svg': {
    display: 'none !important',
  },
}));

export const ProfileDropIcon = styled('span')(({ theme }) => ({
  position: 'absolute',
  right: 9,
  top: 17,
  color: theme.palette.primary.main,
}));
